// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"235d844e","83":"768ec34f","141":"5dc90b9a","260":"30b0d580","581":"bc398227","659":"15e286da","855":"9e2c0324","892":"64d442fe","899":"41c328d0","937":"04580df0"}[chunkId] + ".chunk.js";
};